"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiPostUserRequestPrivilegeEnum = void 0;
exports.instanceOfApiPostUserRequest = instanceOfApiPostUserRequest;
exports.ApiPostUserRequestFromJSON = ApiPostUserRequestFromJSON;
exports.ApiPostUserRequestFromJSONTyped = ApiPostUserRequestFromJSONTyped;
exports.ApiPostUserRequestToJSON = ApiPostUserRequestToJSON;
exports.ApiPostUserRequestToJSONTyped = ApiPostUserRequestToJSONTyped;
/**
 * @export
 */
exports.ApiPostUserRequestPrivilegeEnum = {
    supervisor: 'supervisor',
    admin: 'admin',
    signage: 'signage',
    standard: 'standard'
};
/**
 * Check if a given object implements the ApiPostUserRequest interface.
 */
function instanceOfApiPostUserRequest(value) {
    if (!('username' in value) || value['username'] === undefined)
        return false;
    if (!('password' in value) || value['password'] === undefined)
        return false;
    if (!('privilege' in value) || value['privilege'] === undefined)
        return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined)
        return false;
    if (!('firstname' in value) || value['firstname'] === undefined)
        return false;
    if (!('lastname' in value) || value['lastname'] === undefined)
        return false;
    return true;
}
function ApiPostUserRequestFromJSON(json) {
    return ApiPostUserRequestFromJSONTyped(json, false);
}
function ApiPostUserRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'username': json['username'],
        'password': json['password'],
        'privilege': json['privilege'],
        'tenantId': json['tenant_id'],
        'firstname': json['firstname'],
        'lastname': json['lastname'],
        'isOverrideLoginMethod': json['is_override_login_method'] == null ? undefined : json['is_override_login_method'],
        'loginMethods': json['login_methods'] == null ? undefined : json['login_methods'],
    };
}
function ApiPostUserRequestToJSON(json) {
    return ApiPostUserRequestToJSONTyped(json, false);
}
function ApiPostUserRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'username': value['username'],
        'password': value['password'],
        'privilege': value['privilege'],
        'tenant_id': value['tenantId'],
        'firstname': value['firstname'],
        'lastname': value['lastname'],
        'is_override_login_method': value['isOverrideLoginMethod'],
        'login_methods': value['loginMethods'],
    };
}
